<script>
  import Layout from "../../../layouts/main"
  import Style from "@/views/layouts/style"
  import PageHeader from "@/components/Page-header"
  import appConfig from "../../../../../app.config"
  import CopassMenor10 from "@/components/standard/Copass/ConformacionCopass.Menor10.editar"
  import DontExist from "@/components/company/components/DontExist"
  
  import CompanyAPI from "@/services/company/companyAPI"
  
  /**
   * Form elements component
   */
  export default {
    page: {
      title: "1.1.6 Acta de conformación Copasst Vigía de salud",
      meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
      Layout,
      Style,
      PageHeader,
      CopassMenor10,
      DontExist,
    },
    data() {
      return {
        title: "1.1.6 Acta de conformación Copasst Vigía de salud",
         items: [{
          text: 'Estándares',
          href: '/forms/estandares',
        },
        {
          text: '1.1.6 Acta de conformación Copasst Vigía de salud',
          active: true
        },
        ],
        employeeList: 0,
        
        companyID: this.$store.getters["company/getCompany"].id || null,
        classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
        user: this.$store.state.auth || null,
  
        loading: true,
      }
    },
    methods: {
  
      getEmployeesCount() {
        CompanyAPI.employeesCount(this.companyID)
          .then((response) => {
            this.employeeList = response.companies.employees_count || 0
            this.loading = false
          })
          .catch((error) => {
            console.log(error)
            this.loading = false
          })
      },
    },
    mounted() {
      this.getEmployeesCount()
    },
  }
  </script>
  
  <template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div v-if="!loading && classificationID <= 4 ">
        <div class="animated animatedFadeInUp fadeInUp">
          <CopassMenor10 :companyID="companyID" />
        </div>
      </div>
  
      <div v-else-if="!loading && classificationID > 3">
        <DontExist text="se debe calificar la empresa para poder proceder." />
      </div>
  
      <div v-else>
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </div>
    </Layout>
  </template>
  